import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { setAccessToken } from '../../api/client';
import { authApi } from '../../api/auth.api';
import { useAuthStore } from '../../stores/auth.store';
import LoadingScreen from '../../components/ui/LoadingScreen';

export default function AuthCallbackPage() {
  const navigate   = useNavigate();
  const { setAuth } = useAuthStore();
  const { t } = useTranslation();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get('token');
    const error  = params.get('error');
    const acceptedTripId = params.get('acceptedTripId');

    if (error || !token) {
      navigate('/login?error=google_failed', { replace: true });
      return;
    }

    setAccessToken(token);
    authApi.me()
      .then(user => {
        setAuth(user, token);
        sessionStorage.removeItem('auth-redirect');
        const target = acceptedTripId
          ? `/trips/${acceptedTripId}/itinerary`
          : (() => {
              const stashed = sessionStorage.getItem('auth-redirect');
              return stashed && stashed.startsWith('/') ? stashed : '/dashboard';
            })();
        if (!user.termsAcceptedAt) {
          navigate(`/complete-profile?redirect=${encodeURIComponent(target)}`, { replace: true });
          return;
        }
        navigate(target, { replace: true });
      })
      .catch(() => navigate('/login?error=google_failed', { replace: true }));
  }, []);

  return (
    <div style={{ background: '#faf7f0' }}>
      <LoadingScreen fullscreen label={t('auth.callback.signingIn')} />
    </div>
  );
}
